import { createAsyncThunk } from "@reduxjs/toolkit";
import { authMe } from "helpers/backend_helper";
import 'react-toastify/dist/ReactToastify.css';
import { Constant } from "utils/enums";

export const getAuthMe = createAsyncThunk("auth/me", async () => {
  try {
    const response = await authMe();

    const userMain = JSON.stringify(response);
    localStorage.setItem(Constant.user, userMain);
    return response;
  } catch (error) {
    return null;
  }
});
